export enum ProcessHistoryTypes {
	None = 0,
	ActivateInactivateAccountsUtility = 1,
	GrantYearAccountsUtility = 2,
	ChangeEmployeeJobAccountsUtility = 3,
	ChangeEnableDisableDeductionUtility = 4,
}

export const ProcessHistoryTypesArray = [
	{
		Id: 0,
		Description: 'None',
	},
	{
		Id: 1,
		Description: 'Activate / Inactivate Accounts Utility',
	},
	{
		Id: 2,
		Description: 'Grant Year Accounts Utility',
	},
	{
		Id: 3,
		Description: 'Change Employee Job Accounts Utility',
	},
	{
		Id: 4,
		Description: 'Enable/Disable Deduction Utility',
	},
];
